export enum EventStatus {
    NotStarted = 'not_started',
    Playing = 'playing',
    Settled = 'settled',
    Settling = 'settling',
}
